import { buildProps } from '@ll-plus/utils'

export const batchEditingOptions = [
  {
    value: 'comma',
    payload: {
      title: '逗号模式'
    }
  },
  {
    value: 'colon',
    payload: {
      title: '冒号模式'
    }
  }
]

export const batchEditingProps = buildProps({
  value: {
    type: String,
    default: ''
  }
} as const)

export const batchEditingEmits = {
  'update:value': (value: string) => !!value
}
